import React, { useContext, useEffect, useState } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { IonApp, IonRouterOutlet, IonSplitPane, IonContent, IonButton, IonRow, IonCol, IonGrid, IonPage, isPlatform, IonItem, IonLabel, IonInput } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { appPages, appAdminPages } from './components/menuList';
import CryptoJS from "crypto-js";
import {loadingController } from "@ionic/core"

import Menu from './components/Menu';
import Dashboard from './pages/Dashboard/Dashboard';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import './app.css';


import Documentation from './pages/Documentation';
import Login from './components/Accounts/Login';
import SignUp from './components/Accounts/SignUp';
import Settings from './components/Settings';
import Stocks from './pages/Stocks/Stocks';
import CreateInvoice from './pages/CreateInvoice/CreateInvoice';
import Ledger from './pages/Ledger/Ledger';
import InvoiceList from './pages/InvoiceList/InvoiceList';
import CustomerDetail from './pages/Ledger/CustomerDetails/CustomerDetail';
import PrivateRoute from './resources/Authentication/PrivateRoute';
import CompanyDetails from './pages/Settings/CompanyDetails';
import { AuthContext } from './contexts/AuthContext';
import PurchaseEntry from './pages/PurchaseEntry/PurchaseEntry';
import PurchaseList from './pages/PurchaseList/PurchaseList';
import { useLocalStorage } from './resources/Hooks';
import EditInvoice from './pages/EditInvoice/EditInvoice';
import StockItemDetail from './pages/Stocks/StockItemDetail/StockItemDetail';
import { getConfig, setConfig } from './resources/configSettings';
import { useGoogleBackup } from './components/Services/useGoogleBackup';
import Expenses from './pages/Expenses/Expenses';
import Reports from './pages/Reports/Reports';
import ShowInvoice from './pages/Invoice/ShowInvoice/ShowInvoice';
import { APPLINKS } from './resources/AppConst';
import Tools from './pages/Dev/Tools';
const { dashboard, company, login, signup , docs, stockItem, customerDetails, createInvoice, editBill, invoice, invoiceShow, purchaseEntry, purchaseList, ledger, expenses, stocks, reports , dev } = APPLINKS;

window.document.title = "Billin' Inc - V3.5";

const App = () => {
  const { User } = useContext(AuthContext)
  let menulist = User.isAdmin ? appAdminPages : appPages;

  const [firsttime, setfirsttime] = useLocalStorage('firsttime', true)
  const { scheduleOnlineBackup } = useGoogleBackup()

  useEffect(() => {
    scheduleOnlineBackup();
  }, [scheduleOnlineBackup]);

  if (firsttime) {
    let date = Date.now();
    const c = getConfig();
    c.registryDate = date;
    c.expiryDate = date + 60000 * 60 * 24 * 90; //90 days
    setConfig(c);
  }

  const UserFORM = () => {

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [contact, setContact] = useState('');
    const [location, setLocation] = useState('');

    let ip = atob(localStorage.getItem('ipno'));
    const c = getConfig();
    let hash = CryptoJS.SHA1(ip + name).toString();
    const submitForm = (e) => {
      e.preventDefault();
      // console.log('form submit',e);
      
      const data = { 
        name: name, 
        email: email, 
        contact: contact, 
        location: location, 
        serial: ip,
        registryDate : new Date(c.registryDate).toLocaleString(),
        expirationDate : new Date(c.expiryDate).toLocaleString(),
        hash: hash,
        type: c.productType,
      }

      loadingController.create({message: 'Loading...'}).then((response) => {response.present()});

      fetch('/api/db/add', {
        method: 'POST', // or 'PUT'
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then(response => response.json())
        .then(data => {
          console.log('Success:', data);
          setfirsttime(false);
          window.location = '/signup';
          loadingController.dismiss();
        })
        .catch((error) => {
          console.error('Error:', error);
          setfirsttime(false);
          window.location = '/signup';
          loadingController.dismiss();
        });
      // console.log(data);
    }

    return(
    <form onSubmit={submitForm}>
    <IonItem>
      <IonLabel position='floating'>Your Name</IonLabel>
      <IonInput required name="name" value={name} onIonChange={e => setName((e.detail.value).trim())}></IonInput>
    </IonItem>
    <IonItem>
      <IonLabel position='floating'>Contact No.</IonLabel>
      <IonInput required type="tel" name="contact" value={contact} onIonChange={e => setContact((e.detail.value).trim())}></IonInput>
    </IonItem>
    <IonItem>
      <IonLabel position='floating'>Email</IonLabel>
      <IonInput  name="email" type="email" value={email} onIonChange={e => setEmail((e.detail.value).trim())}></IonInput>
    </IonItem>
    <IonItem>
      <IonLabel position='floating'>Location / Address</IonLabel>
      <IonInput name="location" type='text' value={location} onIonChange={e => setLocation((e.detail.value).trim())}></IonInput>
    </IonItem>
    <br />
    <IonButton type='submit'>Get Started</IonButton> 
  </form>
  )}

  const Welcome = () => isPlatform("mobile") ? (
    <IonPage>

      <IonContent fullscreen className='ion-padding'>
        <div className="blank"></div>
        <h2>Welcome to <b>Billin' Inc</b></h2>
        <img className='center' src="./android-chrome-192x192.png" alt="" />
        <p>Easy to use , user-friendly app for Billing, Accounting & Inventory Management. Best for business and traders to keep all their data in easy way.</p>
        <UserFORM/>
      </IonContent>
    </IonPage>
  ) : (
    <IonPage>

      <IonContent fullscreen scrollY='false'>
        <IonGrid className='ion-justify-content-center'>
          <IonRow>
            <IonCol>
              <img className='comp center' alt='' height='300' src='./assets/comp.png' />
              <UserFORM/>
            </IonCol>
            <IonCol class='ion-padding'>
              <div className="blank"></div>
              <h2>Welcome to <b>Billin' Inc</b></h2>
              <img className='center' src="./android-chrome-192x192.png" alt="" />
              <h3>Easy to use , user-friendly app for Billing, Accounting & Inventory Management. Best for business and traders to keep all their data in easy way.</h3>
              
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  )


  return firsttime ? (
    <IonApp>

      <IonReactRouter>
        <IonRouterOutlet>
          <Route path="/" component={Welcome} />
        </IonRouterOutlet>
      </IonReactRouter>
    </IonApp>
  ) : (
    <IonApp>
      <IonReactRouter>
        <IonSplitPane contentId="main">
          <Menu appPages={menulist} />
          <IonRouterOutlet id="main">
            <PrivateRoute path={dashboard} component={Dashboard} exact={true} />
            <Route path={docs} component={Documentation} exact={true} />
            <PrivateRoute path={APPLINKS.settings} component={Settings} exact={true} />
            <Route path={invoiceShow} component={ShowInvoice} exact={true} />
            <Route path={editBill} component={EditInvoice} exact={true} />
            <PrivateRoute path={customerDetails} component={CustomerDetail} exact={true} />
            <PrivateRoute path={stockItem} component={StockItemDetail} exact={true} />
            <PrivateRoute path={createInvoice} component={CreateInvoice} exact={true} />
            <PrivateRoute path={purchaseEntry} component={PurchaseEntry} exact={true} />
            <PrivateRoute path={invoice} component={InvoiceList} exact={true} />
            <PrivateRoute path={expenses} component={Expenses} exact={true} />
            <PrivateRoute path={reports} component={Reports} exact={true} />
            <PrivateRoute path={purchaseList} component={PurchaseList} exact={true} />
            <PrivateRoute path={ledger} component={Ledger} exact={true} />
            <PrivateRoute path={company} component={CompanyDetails} exact={true} />
            <PrivateRoute path={stocks} component={Stocks} exact={true} />
            <Route path={dev} component={Tools} exact={true} />
            <Route path={login} component={Login} exact={true} />
            <Route path={signup} component={SignUp} exact={true} />
            <Route path="/" exact render={() => <Redirect to={dashboard} exact={true} />} />
          </IonRouterOutlet>
        </IonSplitPane>
      </IonReactRouter>
    </IonApp>
  )
};

export default App;
